export type {
  TeachingPopoverCarouselFooterButtonBaseProps as TeachingPopoverCarouselFooterButtonProps,
  TeachingPopoverCarouselFooterButtonBaseState as TeachingPopoverCarouselFooterButtonState,
  TeachingPopoverCarouselFooterButtonSlots,
} from '@fluentui/react-teaching-popover';
